import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useGlobalContext } from "../../../Context/GlobalContext";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ClipLoader from "react-spinners/ClipLoader";
import Cookies from "js-cookie";

const CustomDetail = () => {
  const [isLoading, setIsLoading] = useState(false);
  let subtitle;
  const { baseUrl, selectedStaff, openToast } = useGlobalContext();
  const [staffDetail, setStaffDetail] = useState(null);
  const [allCustomDetail, setAllCustomDetail] = useState([]);
  const [fieldName, setFieldName] = useState("");
  const [description, setDescription] = useState("");
  const [modalIsOpen2, setIsOpen2] = React.useState(false);
  const [editingId, setEditingId] = useState("");


  const getData = async (e) => {
    setIsLoading(true);
    try {

      setIsLoading(true)
      const response = await fetch(baseUrl + "custom-details/", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
        },
      });

      if (response.status === 200) {
        const result = await response.json();
        console.log("result", result)
        const filteredData = result.filter(
          (item) => item.staffId === selectedStaff.staffDetails.id
        );
        setAllCustomDetail(filteredData);
      } else {
        console.error(
          "Failed to retrieve data:",
          response.status,
          response.statusText
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching data:", error);
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    getData()
  }, [])




  function openModal2() {
    setIsOpen2(true);
  }
  function afterOpenModal2() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal2() {
    setIsOpen2(false);
  }

  async function submitField() {
    setIsLoading(true);
    const data = {
      field_name: fieldName,
      field_value: description,
      staffId: selectedStaff?.staffDetails?.id,
    };

    try {
      const response = await fetch(baseUrl + "custom-details", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`

        },
        body: JSON.stringify(data),
      });


      if (response.ok) {
        const result = await response.json();
        // setAllCustomDetail([...allCustomDetail, result?.update]);
        getData();
        openToast("Custom Field Added Successfully", "success");
      } else {
        openToast("An error occurred while adding custom field", "error");
      }
    } catch (error) {
      console.error("Error submitting custom field:", error);
      openToast("An error occurred while adding custom field", "error");
    } finally {
      closeModal2();
      setIsLoading(false);
    }
  }

  async function editCustomField() {
    setIsLoading(true);
    const data = { staffId: selectedStaff?.staffDetails?.id, field_name: fieldName, field_value: description };

    try {
      const response = await fetch(baseUrl + "custom-details/" + editingId, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`

        },
        body: JSON.stringify(data),
      });


      if (response.status === 200) {
        const result = await response.json();
        setAllCustomDetail(
          allCustomDetail.map((item) =>
            item.id === editingId
              ? { ...item, field_name: fieldName, field_value: description }
              : item
          )
        );
        setEditingId("");
        openToast("Custom Field Edited Successfully", "success");
      } else {
        openToast("An error occurred while editing custom field", "error");
      }
    } catch (error) {
      console.error("Error editing custom field:", error);
      openToast("An error occurred while editing custom field", "success");
    } finally {
      setIsLoading(false);
      closeModal2();
    }
  }

  async function deleteCustomDetail(id) {
    try {
      const response = await fetch(baseUrl + "custom-details/" + id, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`

        },
      });



      if (response.status === 200) {
        const result = await response.json();
        setAllCustomDetail(allCustomDetail.filter((item) => item.id !== id));
        openToast("Deleted Custom Field Successfully", "success");
      } else {
        openToast("An error occurred while deleting Aadhaar", "error");
      }
    } catch (error) {
      console.error("Error deleting custom field:", error);
      openToast("An error occurred while deleting the custom field.", "error");
    }
  }


  return (
    <>
      <div className="top-0 flex justify-between items-center bg-white p-[30px] pr-0 xl:pr-[0px] pl-[0] w-[100%]">
        <h3 className="bg-[#fff] shadow-cs pt-[10px] pb-[10px] pl-[14px] rounded-md w-full font-medium">Custom Details</h3>
        {/* <button className='second-btn'>Update Details</button> */}
      </div>

      <div className="md:overflow-hidden overflow-x-scroll">
        <table className="shadow-cs rounded-[10px] w-full overflow-hidden table-auto table-section">
          <thead
            // onClick={toggleAccordion}
            className="top-[-1px] sticky border-gray-300 bg-white set-shadow shadow-md border cursor-pointer"
          >
            <th className="border-[#dbdbdb] border">Custom Field</th>
            <th className="border-[#dbdbdb] border">Custom Value</th>
            <th className="border-[#dbdbdb] border">Action</th>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={3} className="py-4 text-center">
                  <ClipLoader color="#24007a" size={50} />
                </td>
              </tr>
            ) : allCustomDetail?.length > 0 ? (
              allCustomDetail?.map(({ field_name, field_value, id }) => (
                <tr
                  key={id}
                  className="border-[#dbdbdb] border whitespace-nowrap"
                >
                  <td className="border-[#dbdbdb] p-[10px] border-r whitespace-nowrap">
                    {field_name || ""}
                  </td>
                  <td className="border-[#dbdbdb] p-[10px] border-r whitespace-nowrap">
                    {field_value || ""}
                  </td>
                  <td className="flex justify-center items-center border-[#dbdbdb] p-[10px] border-r whitespace-nowrap">
                    <button
                      onClick={() => {
                        openModal2();
                        setEditingId(id);
                        setFieldName(field_name || "");
                        setDescription(field_value || "");
                      }}
                      className="hover:bg-blue-50 px-3 py-1 rounded text-blue-600 text-sm hover:text-blue-700"
                    >
                      <BorderColorIcon className="font-light text-[#27004a] text-[10px] cursor-pointer" />
                    </button>
                    <button
                      onClick={() => {
                        console.log(id);
                        deleteCustomDetail(id);
                      }}
                      className="hover:bg-red-50 px-3 py-1 rounded text-red-600 text-sm hover:text-red-700"
                    >
                      <DeleteOutlineIcon className="font-light text-[10px] text-red-500 cursor-pointer" />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={3}
                  className="py-4 text-[#FF0000] text-center"
                >
                  No Custom Details
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

      <button
        onClick={openModal2}
        className="flex items-center mt-10 font-normal text-[14px]"
      >
        <AddIcon className="bg-[#27004a] mr-3 rounded-full text-[#fff] text-[10px]" />
        Add Custom Field{" "}
      </button>

      <Modal
        isOpen={modalIsOpen2}
        onAfterOpen={afterOpenModal2}
        onRequestClose={closeModal2}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="p-3 border-b-1 text-[13px] xl:text-[15px]"
        >
          Add Custom Field
        </h2>
        <button
          onClick={closeModal2}
          className="top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold"
        >
          <CloseIcon className="bg-[#27004a] rounded-2xl text-white" />
        </button>
        <div className="">
          <div className="p-[10px] border border-t field-modal modal-field">
            <label className="font-medium text-[13px] xl:text-[14px]">
              Custom Field Name
            </label>
            <br />
            <input
              type="text"
              required
              value={fieldName}
              onChange={(e) => {
                setFieldName(e.target.value);
              }}
              className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
            />
            <br />

            <label className="font-medium text-[13px] xl:text-[14px]">
              Description
            </label>
            <br />
            <textarea
              type="text"
              required
              value={description}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              className="border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
            />
            <br />
          </div>
          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
            <button className="first-btn" onClick={closeModal2}>
              Cancel
            </button>
            <button
              className={
                "second-btn " +
                (isLoading && "animate-pulse cursor-not-allowed")
              }
              disabled={isLoading}
              onClick={() => {
                if (editingId !== "") {
                  editCustomField();
                } else {
                  submitField();
                }
              }}
            >
              {editingId !== "" ? " Edit " : " Add "} Custom Field{" "}
            </button>
          </div>
        </div>
      </Modal>
      {/* </div> */}
    </>
  );
};

export default CustomDetail;
